import { type FC } from "react";
import * as styles from "./styles.css";

type Props = {
  /**
   * コンポーネントに適用するクラス名
   */
  className?: string;
  /**
   * コンテンツ部分の内容
   */
  children: React.ReactNode;
  /**
   * 開かれているかどうかの真偽値
   */
  isOpen: boolean;
  /**
   * 閉じるボタンを押下したときのハンドラ
   */
  onClickClose?: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export const ModelessDialog: FC<Props> = ({ className, children, isOpen, onClickClose }) => {
  return isOpen ? (
    <div
      className={`
        ${styles.container}
        ${className || ""}
      `}
    >
      <button className={styles.closeButton} type="button" onClick={onClickClose}>
        <i className={`c-icn c-icn-cross-thin ${styles.closeButtonIcon}`} />
      </button>
      {children}
    </div>
  ) : null;
};
